import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLegacyAutomationRedirectSummaryRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-redirect-summary',
	path: '/projects/:projectKey/settings/automation/',
};
